export enum EnumTipoConceptoFlotante {
  Distribucion = 1,
  CicloAuxiliar = 2,
  Manual = 3,
  Refacturacion = 4,
  BateriaVirtual = 5,
  AccionBalance = 6,
  Penalizacion = 7
}
